import React from 'react';

interface ProcessingProgressProps {
  current: number;
  total: number;
}

export default function ProcessingProgress({
  current,
  total
}: ProcessingProgressProps) {
  const progress = total > 0 ? Math.round((current / total) * 100) : 0;

  return (
    <div className="space-y-2">
      <div className="flex justify-between text-sm text-[#c8c2bd]">
        <span>Processing invoices...</span>
        <span>{current} of {total}</span>
      </div>
      <div className="h-2 bg-black/50 rounded-full overflow-hidden">
        <div
          className="h-full bg-indigo-600 transition-all duration-300"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
}